// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MapImageryOptions } from 'roofsnap-map-imagery';
import {getSketchOrder} from "../../actions/sketchOrderActions";
import RoofSnapSnackBar from "../../components/RoofSnapSnackBar";
import featureFlags from '../../lib/FeatureFlags';

type ProvidedProps = {
    dispatch: Function,
    accessToken: string,
    history: {
        push: Function,
    },
    match: {
        params: {
            id: string,
        }
    },
    isSketchOsAdmin: boolean,
};

type State = {
    latitude: ?number,
    longitude: ?number,
    projectId: ?string,
    snackBar: boolean,
    message: string,
    messageType: '' | 'success' | 'error',
};

class MapImageryOptionsHost extends Component<ProvidedProps, State> {
    state: State = {
        latitude: null,
        longitude: null,
        projectId: null,
        snackBar: false,
        message: '',
        messageType: '',
    };

    async componentDidMount(): Promise<void> {
        await this.setUp();
    }

    setUp = async () => {
        const result = await this.props.dispatch(getSketchOrder(this.props.match.params.id));
        if (!result.response) {
            return;
        }
        const { location, projectId } = result.response;

        this.setState({
            latitude: location.coordinates[1],
            longitude: location.coordinates[0],
            projectId
        })
    };

    goToSketch = () => {

        const projectId = this.state.projectId ? this.state.projectId : '';
        if(projectId === '') {
            console.warn('projectId was falsy');
        }
        const url = window.location.href.includes('showExp')
            ? `/orders/${this.props.match.params.id}/sketch/${projectId}?showExp=true`
            : `/orders/${this.props.match.params.id}/sketch/${projectId}`;
        this.props.history.push(url);
    };

    handleError = (error) => {
        this.setState({
            messageType: 'error',
            message: error.message,
        });
    };

    handleSnackBarClose = () => {
        this.setState({ snackBar: false });
    };

    handleOnEvent = (event) => {
        switch(event.type) {
            case 'ZOOM_IN':
                window.gtag('event', event.type, {
                    'event_category': 'Map Imagery',
                    'event_label': event.data.imageSource,
                    'event_value': event.data.newZoomLevel,
                    'previous_zoom_level': event.data.previousZoomLevel,
                    'new_zoom_level': event.data.newZoomLevel,
                });
                break;
            case 'ZOOM_OUT':
                window.gtag('event', event.type, {
                    'event_category': 'Map Imagery',
                    'event_label': event.data.imageSource,
                    'event_value': event.data.newZoomLevel,
                    'previous_zoom_level': event.data.previousZoomLevel,
                    'new_zoom_level': event.data.newZoomLevel,
                });
                break;
            default:
                break;
        }
    };

    render() {
        return (
            <div style={{ position: 'relative'}}>
                {
                    this.state.projectId &&
                    <MapImageryOptions
                        jwt={this.props.accessToken}
                        roofSnapApiBaseUrl={process.env.REACT_APP_API_HOST}
                        nearmapApiBaseUrl={process.env.REACT_APP_NEARMAP_PROXY_API_HOST}
                        hexagonApiBaseUrl={process.env.REACT_APP_HEXAGON_PROXY_API_HOST}
                        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                        latitude={this.state.latitude}
                        longitude={this.state.longitude}
                        projectId={this.state.projectId}
                        onSaveImageComplete={this.goToSketch}
                        nearmapApiKey={null}
                        onError={this.handleError}
                        onStepChange={(step) => {}}
                        onImagerySelected={(source) => {}}
                        onEvent={this.handleOnEvent}
                        nearmapAutoZoomLevel={this.props.isSketchOsAdmin ? 1 : 0}
                        rsClient="ShadyShark"
                        vexcelDisabled={!featureFlags.vexcelImagery}
                        roofsnapImageryApiBaseUrl={`${process.env.REACT_APP_ROOFSNAP_IMAGERY_HOST}`}
                        disableParcelLines={!featureFlags.parcelLines}
                        parcelSdkUrl={process.env.REACT_APP_PARCEL_STREAM_URL}
                        spatialStreamUrl={process.env.REACT_APP_SPATIAL_STREAM_URL}
                        jwtProxyUrl={process.env.REACT_APP_ROOFSNAP_JWT_PROXY}
                    />
                }

                <RoofSnapSnackBar
                    open={this.state.snackBar}
                    message={this.state.message}
                    onClose={this.handleSnackBarClose}
                    variant={this.state.messageType}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { auth, currentUserRoles } = state;
    const { isSketchOsAdmin } = currentUserRoles;
    const { accessToken } = auth;

    return {
        accessToken,
        isSketchOsAdmin,
    }
};

export default connect(mapStateToProps)(MapImageryOptionsHost);
